import { defaultsPlugin } from '../defaults';
import { commonServicesPlugin } from '../common-services';
import { editorLocationPlugin } from '../editor-location';
import { editorNavigationPlugin } from '../editor-navigation';
export function editorPlugin(flowApi) {
  return function (router) {
    router.plugin(commonServicesPlugin());
    router.plugin(defaultsPlugin(flowApi));
    router.plugin(editorLocationPlugin(flowApi));
    router.plugin(editorNavigationPlugin(flowApi));
    return {
      name: 'WixUIRouterEditor'
    };
  };
}
//# sourceMappingURL=plugin.js.map